<template>
    <div>
        <div class="flex justify-center" v-if="loading">
            <propagate-loader class="spinner" color="#3C959D" :loading="loading" :size="50"></propagate-loader>
        </div>
        <div v-if="is_url_expiration == false">
            <div class="bg-goodGreen mt-2 lg:mt-5">
                <span class="text-white font-semibold ml-5 lg:ml-20 xl:ml-20 text-3xl md:text-4xl lg:text-4xl xl:text-4xl">Datos del Socio</span>
            </div>

            <div class="ml-5 lg:ml-20 xl:ml-20 mt-5 flex flex-wrap justify-center">
                <div class="w-full md:w-1/3 lg:w-1/3 xl:w-1/3">
                    <p class="text-goodGreen">RFC</p>
                    <p class="font-semibold">{{rfc}}</p>
                </div>

                <div class="w-full md:w-1/3 lg:w-1/3 xl:w-1/3">
                    <p class="text-goodGreen">Nombre Completo</p>
                    <p class="font-semibold">{{name}}</p>
                </div>

                <div class="w-full md:w-1/3 lg:w-1/3 xl:w-1/3">
                    <p class="text-goodGreen">Sexo</p>
                    <p class="font-semibold">{{gender}}</p>
                </div>
            </div>
            
            <div class="ml-5 lg:ml-20 xl:ml-20 mt-5 flex flex-wrap justify-center">
                <div class="w-full md:w-1/3 lg:w-1/3 xl:w-1/3">
                    <p class="text-goodGreen">Contacto de Emergencía(Nombre completo)</p>
                    <p class="font-semibold">{{emergency_contact_full_name}}</p>
                </div>

                <div class="w-full md:w-1/3 lg:w-1/3 xl:w-1/3">
                    <p class="text-goodGreen">No. de Telefono</p>
                    <p class="font-semibold">{{emergency_contact_phone_number}}</p>
                </div>

                <div class="w-full md:w-1/3 lg:w-1/3 xl:w-1/3">
                    <p class="text-goodGreen">Parentesco o Relación</p>
                    <p class="font-semibold">{{emergency_contact_relationship}}</p>
                </div>
            </div>

            <div class="bg-goodGreen mt-5">
                <span class="text-white font-semibold ml-5 lg:ml-20 xl:ml-20 text-3xl md:text-4xl lg:text-4xl xl:text-4xl">Beneficios</span>
            </div>

            <div class="ml-5 lg:ml-20 xl:ml-20 mt-5 flex flex-wrap justify-center">
                <div class="w-1/2 md:w-1/3 lg:w-1/3 xl:w-1/3">
                    <p class="text-goodGreen">Beneficios de FAS</p>
                    <!-- <p v-for="product in benefitFAS.product" :key="product.id" class="font-semibold">{{product}}</p> -->
                    <p class="font-semibold">Ahorro</p>
                    <p v-if="is_previous_letter" class="font-semibold">Retiro</p>
                    <p class="font-semibold">Defunción del Agremiado</p>
                </div>

                <div class="px-2 w-1/2 md:w-1/3 lg:w-1/3 xl:w-1/3 text-right md:text-center lg:text-center xl:text-center">
                    <p class="text-goodGreen">Aporte Quincenal</p>
                    <!-- <p v-for="cost in benefitFAS.cost" :key="cost.id" class="font-semibold">{{cost}}</p> -->
                    <p class="font-semibold">{{this.savings_info.amount}}</p>
                    <p v-if="is_previous_letter" class="font-semibold">{{this.retirement_amount}}</p>
                    <p class="font-semibold">{{this.death_amount}}</p>
                </div>

                <div class="w-1/2 md:w-1/3 lg:w-1/3 xl:w-1/3">
                    <p class="text-goodGreen"></p>
                    <p class="font-semibold"></p>
                </div>
            </div>

            <div v-if="is_new_letter">
                <div class="ml-5 lg:ml-20 xl:ml-20 mt-5 flex flex-wrap justify-center">
                    <div class="w-full md:w-1/3 lg:w-1/3 xl:w-1/3 text-center md:text-left lg:text-left xl:-text-left">
                        <p class="text-goodGreen">Recuperación al termino del plazo</p>
                        <p class="font-semibold text-center">{{this.death_recovery}}</p>
                    </div>

                    <div class="w-1/2 md:w-1/3 lg:w-1/3 xl:w-1/3 text-center mt-2">
                        <p class="text-goodGreen">V.A.P</p>
                        <p class="font-semibold">{{this.death_vap}}</p>
                    </div>

                    <div class="w-1/2 md:w-1/3 lg:w-1/3 xl:w-1/3 text-center mt-2">
                        <p class="text-goodGreen">Invalidez</p>
                        <p class="font-semibold">{{this.death_disability}}</p>
                    </div>
                </div>

                <div class="ml-5 lg:ml-20 xl:ml-20 mt-5 flex flex-wrap justify-center">
                    <div class="w-1/2 md:w-1/3 lg:w-1/3 xl:w-1/3">
                        <p class="text-goodGreen text-center md:text-left lg:text-left xl:text-left">Defunción unicamente por condiciones de salud</p>
                        <p class="font-semibold text-center">{{this.death_benefit}}</p>
                    </div>
                    <div class="w-full md:w-1/3 lg:w-1/3 xl:w-1/3"></div>
                    <div class="w-full md:w-1/3 lg:w-1/3 xl:w-1/3"></div>
                </div>
            </div>

            <div v-if="is_previous_letter">
                <div class="ml-5 lg:ml-20 xl:ml-20 mt-5 flex flex-wrap justify-center">
                    <div class="w-1/2 md:w-1/3 lg:w-1/3 xl:w-1/3 text-center mt-2">
                        <p class="text-goodGreen">Beneficios para el socio</p>
                        <p class="font-semibold">{{this.death_partner_benefit}}</p>
                    </div>

                    <div class="w-1/2 md:w-1/3 lg:w-1/3 xl:w-1/3 text-center mt-2">
                        <p class="text-goodGreen">Beneficios para la familia</p>
                        <p class="font-semibold">{{this.death_family_benefit}}</p>
                    </div>

                </div>
            </div>

            <div class="bg-goodGreen mt-5">
                <span class="text-white font-semibold ml-5 lg:ml-20 xl:ml-20 text-3xl md:text-4xl lg:text-4xl xl:text-4xl">Beneficios Adicionales</span>
            </div>

            <div class="lg:ml-20 xl:ml-20 mt-5 flex flex-wrap justify-center">
                <div class="w-full md:w-1/5 lg:w-1/5 xl:w-1/5 text-center mt-2">
                    <p class="text-goodGreen ml-5 md:ml-1 lg:-ml-1 xl:ml-1">Beneficios Adicionales</p>
                    <!-- <p class="font-semibold ml-5 md:ml-1 lg:-ml-1 xl:ml-1">{{aditionalBenefit}}</p> -->
                    <p v-for="(benefit_vt) in benefits_vt" :key="benefit_vt.id" class="font-semibold">{{aditionalBenefit}}</p>
                </div>

                <div class="w-1/2 md:w-1/5 lg:w-1/5 xl:w-1/5 text-center mt-2">
                    <p class="text-goodGreen">Beneficio</p>
                    <!-- <p class="font-semibold">{{benefit}}</p> -->
                    <p v-for="(benefit_vt) in benefits_vt" :key="benefit_vt.id" class="font-semibold">{{benefit_vt.benefit_amount}}</p>
                </div>

                <div class="w-1/2 md:w-1/5 lg:w-1/5 xl:w-1/5 text-center mt-2">
                    <p class="text-goodGreen">Fecha de Adquisición</p>
                    <!-- <p class="font-semibold">{{adquisitionDate}}</p> -->
                    <p v-for="(benefit_vt) in benefits_vt" :key="benefit_vt.id" class="font-semibold">{{benefit_vt.acquisition_date}}</p>
                </div>

                <div class="w-1/2 md:w-1/5 lg:w-1/5 xl:w-1/5 text-center mt-2">
                    <p class="text-goodGreen">Invalidez</p>
                    <!-- <p class="font-semibold">{{disabilityBA}}</p> -->
                    <p v-for="(benefit_vt) in benefits_vt" :key="benefit_vt.id" class="font-semibold">{{benefit_vt.disability}}</p>
                </div>

                <div class="w-1/2 md:w-1/5 lg:w-1/5 xl:w-1/5 text-center mt-2">
                    <p class="text-goodGreen">Aportación Quincenal</p>
                    <!-- <p class="font-semibold">{{aportation}}</p> -->
                    <p v-for="(benefit_vt) in benefits_vt" :key="benefit_vt.id" class="font-semibold">{{benefit_vt.contribution}}</p>
                </div>

                <div class="w-1/2 md:w-1/3 lg:w-1/3 xl:w-1/3 text-center mt-5">
                    <p class="text-goodGreen">V.A.P.</p>
                    <!-- <p class="font-semibold">{{vap}}</p> -->
                    <p v-for="(benefit_vt) in benefits_vt" :key="benefit_vt.id" class="font-semibold">{{benefit_vt.vap}}</p>
                </div>

                <div class="w-1/2 md:w-1/3 lg:w-1/3 xl:w-1/3 text-center mt-5">
                    <p class="text-goodGreen md:text-center lg:text-center xl:text-center">Fecha estimada de recuperación</p>
                    <!-- <p class="font-semibold md:text-center lg:text-center xl:text-center">{{recoverDate}}</p> -->
                    <p v-for="(benefit_vt) in benefits_vt" :key="benefit_vt.id" class="font-semibold">{{benefit_vt.recovery_date}}</p>
                </div>

                <div class="w-1/2 md:w-1/3 lg:w-1/3 xl:w-1/3 text-center mt-5">
                    <p class="text-goodGreen">Recuperación al termino del plazo</p>
                    <!-- <p class="font-semibold">{{recover}}</p> -->
                    <p v-for="(benefit_vt) in benefits_vt" :key="benefit_vt.id" class="font-semibold">{{benefit_vt.recovery}}</p>
                </div>
            </div>
    
            <div class="bg-goodGreen mt-5">
                <span class="text-white font-semibold ml-5 lg:ml-20 xl:ml-20 text-3xl md:text-4xl lg:text-4xl xl:text-4xl">Indemnizaciones</span>
            </div>
            <div class="showInSmallScreens text-center">
                <div class="ml-2 mr-2 lg:ml-20 xl:ml-20 mt-5 flex flex-wrap justify-center">
                    <table class="mt-5 mb-5 w-full">
                        <tr class="text-goodGreen">
                            <th class="text-center font-normal">Indemnización</th>
                            <th class="text-center font-normal">Modulos</th>
                            <th class="text-center font-normal">Tipo</th>
                            <th class="text-center font-normal">Protección</th>
                            <th class="text-center font-normal">Beneficiario</th>
                            <th class="text-center font-normal">Fecha de Adquisición</th>
                            <th class="text-center font-normal">Aportación Quincenal</th>
                        </tr>
                        <tr v-for="cancer_info in cancer_info" :key="cancer_info.id">
                            <td class="text-center" style="height: 30px;">
                                <span class="font-semibold">Cancer</span>
                                <br/>
                            </td>                            
                            <td class="font-semibold text-center mb-5">{{cancer_info.modules}}</td>
                            <td class="font-semibold text-center mb-5">{{cancer_info.type}}</td>
                            <td class="font-semibold text-center mb-5">{{cancer_info.benefit}}</td>
                            <td class="font-semibold text-center mb-5">{{cancer_info.beneficiary}}</td>
                            <td class="font-semibold text-center mb-5">{{cancer_info.acquisition_date}}</td>
                            <td class="font-semibold text-center mb-5">{{cancer_info.contribution}}</td>
                        </tr>

                        <tr v-for="eg_info in eg_info" :key="eg_info.id">
                            <td class="text-center" style="height: 30px;">
                                <span class="font-semibold">EG</span>
                                <br/>
                            </td>                            
                            <td class="font-semibold text-center mb-5">{{eg_info.modules}}</td>
                            <td class="font-semibold text-center mb-5">{{eg_info.type}}</td>
                            <td class="font-semibold text-center mb-5">{{eg_info.benefit}}</td>
                            <td class="font-semibold text-center mb-5">{{eg_info.beneficiary}}</td>
                            <td class="font-semibold text-center mb-5">{{eg_info.acquisition_date}}</td>
                            <td class="font-semibold text-center mb-5">{{eg_info.contribution}}</td>
                        </tr>
                    </table>

                </div>
            </div>

            <div class="hideInSmallScreens">
                <div class="ml-5 mr-5 lg:ml-20 xl:ml-20 mt-5 flex flex-wrap justify-center">
                    <table class="mt-5 mb-5 w-full">
                        <tr class="text-goodGreen">
                            <th class="text-center font-normal">Indemnización</th>
                            <th class="text-center font-normal">Modulos</th>
                            <th class="text-center font-normal">Tipo</th>
                            <th class="text-center font-normal">Protección</th>
                            <th class="text-center font-normal">Beneficiario</th>
                            <th class="text-center font-normal">Fecha de Adquisición</th>
                            <th class="text-center font-normal">Aportación Quincenal</th>
                        </tr>
                        <tr v-for="cancer_info in cancer_info" :key="cancer_info.id">
                            <td class="text-center" style="height: 30px;">
                                <span class="font-semibold">Cancer</span>
                                <br/>
                            </td>                            
                            <td class="font-semibold text-center mb-5">{{cancer_info.modules}}</td>
                            <td class="font-semibold text-center mb-5">{{cancer_info.type}}</td>
                            <td class="font-semibold text-center mb-5">{{cancer_info.benefit}}</td>
                            <td class="font-semibold text-center mb-5">{{cancer_info.beneficiary}}</td>
                            <td class="font-semibold text-center mb-5">{{cancer_info.acquisition_date}}</td>
                            <td class="font-semibold text-center mb-5">{{cancer_info.contribution}}</td>
                        </tr>

                        <tr v-for="eg_info in eg_info" :key="eg_info.id">
                            <td class="text-center" style="height: 30px;">
                                <span class="font-semibold">EG</span>
                                <br/>
                            </td>                            
                            <td class="font-semibold text-center mb-5">{{eg_info.modules}}</td>
                            <td class="font-semibold text-center mb-5">{{eg_info.type}}</td>
                            <td class="font-semibold text-center mb-5">{{eg_info.benefit}}</td>
                            <td class="font-semibold text-center mb-5">{{eg_info.beneficiary}}</td>
                            <td class="font-semibold text-center mb-5">{{eg_info.acquisition_date}}</td>
                            <td class="font-semibold text-center mb-5">{{eg_info.contribution}}</td>
                        </tr>
                    </table>
                </div>

                <div class="ml-5 lg:ml-20 xl:ml-20 mt-5 flex flex-wrap justify-center">
                    <div class="w-full">
                        <p class="text-right mr-32">________________________________</p>
                    </div>
                </div>

                <div class="ml-5 lg:ml-20 xl:ml-20 mt-2 mb-5 flex flex-wrap justify-center">
                    <div class="w-1/4">
                        <p class="text-goodGreen"></p>
                        <p class="font-semibold"></p>
                    </div>

                    <div class="w-1/4">
                        <p class="text-goodGreen"></p>
                        <p class="font-semibold"></p>
                    </div>

                    <div class="w-1/4">
                        <p class="text-goodGreen text-center">Aportación Quincenal</p>
                    </div>

                    <div class="w-1/4">
                        <p class="font-semibold text-center mr-24">{{total_contribution}}</p>
                    </div>
                </div>
            </div>

            <div class="bg-goodGreen">
                <div class="ml-5 lg:ml-20 xl:ml-20">
                    <span class="text-white font-semibold  text-3xl md:text-4xl lg:text-4xl xl:text-4xl">Beneficiarios por fallecimiento del Socio</span>
                </div>
            </div>
        
            <div class="showInSmallScreens text-center">
                <div class="ml-2 mr-2 lg:ml-5 lg:ml-20 xl:ml-20 mt-5 lg:flex-wrap justify-center">
                    <div v-for="beneficiaries in beneficiariesDecease" :key="beneficiaries.id" class="w-full">
                        <div class="w-full mt-5">
                            <p class="text-goodGreen">Nombres</p>
                            <p class="font-semibold">{{beneficiaries.name}}</p>
                        </div>

                        <div class="w-full inline-flex mt-5">
                            <div class="w-1/2">
                                <p class="text-goodGreen">Fecha de Nacimiento</p>
                                <p class="font-semibold">{{beneficiaries.birthday}}</p>
                            </div>

                            <div class="w-1/2">
                                <p class="text-goodGreen text-center">Parentesco</p>
                                <p class="font-semibold text-center">{{beneficiaries.kinship}}</p>
                            </div>
                        </div>

                        <div class="w-full mt-5">
                            <p class="text-goodGreen text-center">Porcentaje (%)</p>
                            <p class="font-semibold text-center">{{beneficiaries.percentage}}</p>
                        </div>
                    </div>
                </div>
            </div>

            <div>
                <div class="hideInSmallScreens">
                    <div class="ml-20 mt-5 flex flex-wrap justify-center">
                        <div class="w-1/4">
                            <p class="text-goodGreen">Nombres</p>
                            <p v-for="beneficiaries in beneficiariesDecease" :key="beneficiaries.id" class="font-semibold">{{[beneficiaries.paternal_name, beneficiaries.maternal_name, beneficiaries.name, beneficiaries.middle_name].filter(x=>x).join(" ")}}</p>
                        </div>

                        <div class="w-1/4">
                            <p class="text-goodGreen text-center">Fecha de Nacimiento</p>
                            <p v-for="beneficiaries in beneficiariesDecease" :key="beneficiaries.id" class="font-semibold text-center">{{beneficiaries.birthday}}</p>
                        </div>

                        <div class="w-1/4">
                            <p class="text-goodGreen text-center">Parentesco</p>
                            <p v-for="beneficiaries in beneficiariesDecease" :key="beneficiaries.id" class="font-semibold text-center">{{beneficiaries.kinship}}</p>
                        </div>

                        <div class="w-1/4">
                            <p class="text-goodGreen text-center">%</p>
                            <p v-for="beneficiaries in beneficiariesDecease" :key="beneficiaries.id" class="font-semibold text-center">{{beneficiaries.percentage}}</p>
                        </div>
                    </div>
                </div>
            </div>

            <hr class="showInSmallScreens mt-5 mb-5 bg-goodGreen h-px mx-16">
            <hr class="hideInSmallScreens mt-10 bg-goodGreen h-px mx-24">

            <div class="container mt-10 px-10 lg:px-24">
                <p class="text-xl text-center lg:text-left">
                    Autorizo al Comité Técnico para que tramite ante quien corresponda, los descuentos quincenales de acuerdo a los beneficios del programa a los cuales acepto permanecer.
                </p>
                <p class="text-xl text-center lg:text-left font-semibold mt-10">
                    Manifiesto bajo protesta de decir la verdad, que al momento de mi inscripción no padezco ninguna enfermedad. En caso de omitir algún(os) padecimiento(os) deslindado al FAS de la responsabilidad del pago de indemnización. (Anexo copia del talón de cheques y de identificación oficial).
                </p>
            </div>

            <div class="text-center mt-10 mb-10 px-10 items-center">
                <input type="checkbox" class="mr-2" v-model="acceptConditions">
                <span>He leído y acepto las condiciones del </span><a class="text-goodGreen" href="" v-on:click.prevent="getPrivacynotice()">Aviso de Privacidad</a>
            </div>

            <!-- <div class="text-center mt-5 mb-5">
                <button class="bg-darkGray hover:bg-lightGray text-xl py-1 px-20 m-2 rounded-full">
                    Sí
                </button>
                <button class="bg-darkGray hover:bg-lightGray text-xl py-1 px-20 m-2 rounded-full">
                    No
                </button>
            </div> -->

            <div class="text-center">
                <p class="text-goodGreen text-2xl font-semibold">Firma Digital</p>
                <p class="px-5">Realice su firma como en su identificación oficial</p>
            </div>

            <div class="w-full mt-5">
                <div class="flex flex-col lg:flex-row justify-center">
                    <!-- <div class="w-full"></div> -->
                    <div class="w-full flex justify-center">
                        <VueSignaturePad
                            id="signature"
                            width="45%"
                            height="150px"
                            ref="signaturePad"
                            :options="options"
                        />
                    </div>
                    <!-- <div class="w-full"></div> -->
                </div>

                <div class="text-center mt-5 mb-5">
                    <!-- <div class="w-1/3"></div>
                    <div class="w-1/3"> -->
                    <!-- <button @click="save" class="mt-5 bg-darkGray hover:bg-lightGray text-xl py-1 px-20 rounded-full">
                            Ver
                    </button> -->
                    <button @click="undo" class="mt-5 bg-darkGray hover:bg-lightGray text-xl py-1 px-20 rounded-full">
                        Deshacer
                    </button>
                    <!-- </div> -->
                    <div class="w-1/3"></div>
                </div>
            </div>

            <div class="text-center px-5" v-if="acceptConditions == false">
                <span class="text-red-600 text-xl font-semibold">Debes aceptar las condiciones del Aviso de Privacidad para continuar</span>
            </div>

            <div class="text-center px-5" v-if="is_signed_empty == true">
                <span class="text-red-600 text-xl font-semibold">Debes ingresar la firma como identificación oficial para continuar</span>
            </div>

            <div class="text-center px-5" v-if="document_signed == true">
                <span class="text-red-600 text-xl font-semibold">El documento ya ha sido firmado</span>
            </div>

            <div class="flex justify-center w-full mt-10 mb-5" v-if="loading_finish">
                <propagate-loader class="w-full flex justify-center spinner" color="#3C959D" :loading_finish="loading_finish" :size="50"></propagate-loader>
            </div>

            <div class="text-center mt-5 mb-5" v-if="show_finish">
                <button @click="goToPDF" class="bg-normalYellow hover:bg-hoverYellow text-white text-xl py-1 px-20 rounded-full">
                    Finalizar
                </button>
            </div>
        </div>
        <div v-else-if="is_url_expiration == true">
            <div class="bg-goodGreen mt-2 lg:mt-5">
                <span class="text-white font-semibold ml-5 lg:ml-20 xl:ml-20 text-3xl md:text-4xl lg:text-4xl xl:text-4xl">{{errors}}</span>
            </div>
        </div>
    </div>
</template>

<script>

export default {
  name: 'App',
  data() {
    return {  
      acceptConditions: false,
      options: {
          penColor: "#1F2933"
      },
      apiCcapi: process.env.VUE_APP_URL_CCAPI,
      apiCabsaCore: process.env.VUE_APP_URL_CABSACOREAPI,
      token_auth_valid: "",
      token_auth_ccapi: "",
      loading_finish: false,
      show_finish: true,
      is_previous_letter: false,
      is_new_letter: false,
      is_url_expiration: null,
      url_is_expiration: true,
      is_signed_empty:false,
      errors: null,
      url_response_json: null,
      url_response_pdf: null,
      url_path_response_json: null,
      url_path_response_pdf: null,
      name_catalog_document: null,
      url_path_response_pdf_signed: null,
      notice_of_privacy_type: "",
      is_not_document_signed: true,
      urlParams: null,
      file: null,
      json_file: null,
      personal_information: null,
      document_type: "",
      url_for_download_pdf: "",
      document_signed: false,
      loading: false,
      rfc: "",
      name: "",
      gender: "",
      email:"",
      email_associate: "",
      savings_info: "",
      retirement_amount: "",
      death_info: "",
      death_amount: "",
      death_partner_benefit: "",
      death_family_benefit: "",
      death_recovery: "",
      death_vap: "",
      death_disability: "",
      death_benefit: "",
      benefits_vt: [],
      beneficiariesDecease: [],
      cancer_protection: "",
      cancer_contribution: "",
      cancer_acquisition_date: "",
      ge_info: "",
      contribution_info: "",
      total_contribution: "",
      aditionalBenefit: "Defunción",
      benefit: "Beneficio",
      cancer_info: {
      },
      member_id: 0,
      user_id: 0,
      emergency_contact_full_name: "",
      emergency_contact_phone_number: "",
      emergency_contact_relationship: ""
    }
  },
    methods: {
    getApiErrorMessage(error, fallback = "Ocurrió un error al procesar la solicitud.") {
        return error.response && error.response.data
            ? error.response.data.errores || error.response.data.errors || error.response.data.message || fallback
            : error.message || fallback
    },
    async goToPDF(){ 
        this.show_finish = false
        this.loading_finish = true
        if (this.acceptConditions == true && this.save().isEmpty == false){
            await this.insertDigitalSignatureToFile()
            await this.postUploadFile()
            if (this.is_not_document_signed == true){
                await this.sendEmail()
                localStorage.setItem("pdf_for_download", this.url_for_download_pdf);
                this.$router.push({ name: 'successful-process'});
            }
            this.is_signed_empty = this.save().isEmpty
            this.document_signed = true
        }
        this.loading_finish = false
        this.show_finish = true
    },
    undo() {
      this.$refs.signaturePad.undoSignature();
    },
    save() {
        var result = {
            isEmpty: true,
            data: ""
        }
      const { isEmpty, data } = this.$refs.signaturePad.saveSignature();
        if(isEmpty == false){
            result.isEmpty = isEmpty
            result.data = data.split(",")[1]
        }else{
            this.is_signed_empty = isEmpty
        }
        return result
    },
    change() {
      this.options = {
        penColor: "#1F2933"
      };
    },
    resume() {
      this.options = {
        penColor: "#1F2933"
      };
    },
    async insertDigitalSignatureToFile(){

        let base64_signature = this.save().data
        this.registerSignature(base64_signature)

        this.errors = null
        let config = {
            headers: {
            'Content-Type': 'application/json'
            },
        }
        let data = {
            "token_auth": this.token_auth_ccapi,
            "path_file_to_sign": this.url_path_response_pdf,
            "business_acronym": "fas2",
            "name_catalog_document": this.name_catalog_document,
            "name_catalog_document_notice_of_privacy": this.notice_of_privacy_type,
            "digital_signature": base64_signature
        }
        await this.axios.post(this.apiCcapi + 'digital_signatures/insert_digital_signature_to_file', data, config).then((response) => {
        if (response.data?.response?.path != ""){
          this.url_path_response_pdf_signed = response.data.response.path
          
        }else {
            this.errors = true
        }
        this.loading = false
        }).catch(error => {
            this.errors = this.getApiErrorMessage(error)
            this.loading = false
        });
    },
    async registerSignature(base64_signature) {
      this.errors = null;
      let config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      let data = {
        token_auth: this.token_auth_ccapi,
        signature_file: base64_signature,
        member_id: this.member_id,
        user_id: this.user_id,
        registered: new Date(new Date().getTime() - (new Date().getTimezoneOffset() * 60000)).toISOString()
      };
      await this.axios
        .post(this.apiCcapi + "/fas/signature_fondos/create",data,config)
        .then(() => {
        })
        .catch((error) => {
          this.errors = this.getApiErrorMessage(error)
          this.loading = false;
        });
    },
    async getJsonInformation(){
      this.errors = null
      let config = {
        headers: {
          'Content-Type': 'application/json'
        },
      }
      let data = {
        "token_auth": this.token_auth_ccapi,
        "file_name": this.json_file,
        "business_acronym":"fas2",
        "process":"generate_plan_costs_json"
      }
      await this.axios.post(this.apiCcapi + 'digital_signatures/get_file_cloud', data, config).then((response) => {
        if (response?.data?.response?.url != ""){
          this.url_response_json = response.data.response.url
          this.getJsonInformationFromUrl();
          this.is_url_expiration = false
        }else {
            this.errors = response.data.errores
        }
        this.loading = false
      }).catch(error => {
        this.errors = this.getApiErrorMessage(error)
        this.loading = false
      });
    },
    async getPdfInformation(){
      this.errors = null
      let config = {
        headers: {
          'Content-Type': 'application/json'
        },
      }
      let data = {
        "token_auth": this.token_auth_ccapi,
        "file_name": this.file,
        "business_acronym":"fas2",
        "process":"generate_plan_costs_pdf"
      }
      await this.axios.post(this.apiCcapi + 'digital_signatures/get_file_cloud', data, config).then((response) => {
        if (response?.data?.response?.url != ""){
          this.url_response_pdf = response.data.response.url
          this.url_path_response_pdf = response.data.response.path
        }else {
            this.errors = response.data.errores
        }
        this.loading = false
      }).catch(error => {
        this.errors = this.getApiErrorMessage(error)
        this.loading = false
      });
    },
    getJsonInformationFromUrl(){
        
      this.axios.get(this.apiCcapi + "/download_base64?token_auth=" + this.token_auth_ccapi + "&url=" + this.url_response_json, "", "").then((base64_response) => {
        const response = {data: JSON.parse(atob(base64_response.data.response.result))};
        
        this.personal_information = response.data.obJson.savings_request.application_form.client
        this.rfc = this.personal_information.rfc
        this.name = [this.personal_information.paternal_name, this.personal_information.maternal_name, this.personal_information.name, this.personal_information.middle_name].filter(x=>x).join(" ")
        this.gender = this.personal_information.gender
        this.email = this.personal_information.email
        this.email_associate = response.data.obJson.savings_request.application_form.associate.email
        //this.email = "danielolguin151@gmail.com"
        //this.email_associate = "daniel.olguingcabsa.com.mx"
        this.savings_info = response.data.obJson.savings_request.application_form.savings_info
        this.death_info = response.data.obJson.savings_request.application_form.death_info
        this.benefits_vt = response.data.obJson.savings_request.application_form.vt
        this.beneficiariesDecease = response.data.obJson.savings_request.application_form.beneficiaries
        this.cancer_info = response.data.obJson.savings_request.application_form.cancer_info
        this.ge_info = response.data.obJson.savings_request.application_form.ge_info
        this.contribution_info = response.data.obJson.savings_request.application_form.contribution_info
        this.total_contribution = response.data.obJson.savings_request.application_form.contribution_info.total_contribution
        this.document_type = response.data?.tipo_documento
        this.name_catalog_document = response.data.obJson?.savings_request?.document?.signed_version_name//"plan_costos_firma"
        if (response.data.obJson?.savings_request?.application_form?.retirement_info?.amount != null && parseFloat(response.data.obJson?.savings_request?.application_form?.retirement_info?.amount.replaceAll("$",""))>0){
            this.retirement_amount = response.data.obJson?.savings_request?.application_form?.retirement_info?.amount
            this.death_amount = this.death_info?.amount
            this.death_partner_benefit = this.death_info?.partner_benefit
            this.death_family_benefit = this.death_info?.family_benefit
            this.notice_of_privacy_type = ""
            this.is_previous_letter = true
        }else{
            this.death_amount = this.death_info?.amount
            this.death_recovery = this.death_info?.recovery
            this.death_vap = this.death_info?.vap
            this.death_disability = this.death_info?.disability
            this.death_benefit = this.death_info?.benefit
            this.notice_of_privacy_type = ""
            this.is_new_letter = true
        }
        
        this.cancer_info = response.data.obJson.savings_request.application_form.cancer;

        this.eg_info = response.data.obJson.savings_request.application_form.eg;

        this.user_id = response.data.obJson.savings_request.application_form.associate.id;

        this.member_id = response.data.socio_id;

        this.emergency_contact_full_name = [response?.data?.obJson?.savings_request?.application_form?.emergency_contact?.paternal_name, response?.data?.obJson?.savings_request?.application_form?.emergency_contact?.maternal_name, response?.data?.obJson?.savings_request?.application_form?.emergency_contact?.name, response?.data?.obJson?.savings_request?.application_form?.emergency_contact?.middle_name].filter(x=>x).join(" ");
        this.emergency_contact_phone_number = response?.data?.obJson?.savings_request?.application_form?.emergency_contact?.phone_number;
        this.emergency_contact_relationship = response?.data?.obJson?.savings_request?.application_form?.emergency_contact?.relationship;

      }).catch(error => {
        this.errors = this.getApiErrorMessage(error, "No fue posible obtener la información del documento.")
        this.loading = false
      });
    },
    async postUrlExpiration(){
        let config = {
            headers: {
                'Content-Type': 'application/json'
            },
        }
        this.loading = true
        await this.axios.post(this.apiCcapi + 'digital_signatures/expiry_time', { "token_auth": this.token_auth_ccapi, "url": window.location.toString(), "business_acronym": "fas2"}, config).then((response) => {
        if (response.data.errors.length == 0){
            this.url_is_expiration = false
            return true
        }
      }).catch(error => {
        console.error('[postUrlExpiration]', error)
        this.errors = "El documento que desea firmar ya ha vencido, favor de contactar a su asesor."
        this.url_is_expiration = true
        this.is_url_expiration = true
        return false
      });
    },
    async postLogin(){
      let config = {
        headers: {
            'Content-Type': 'application/json'
        },
      }

      let data = {
        "usuario_api": {
            "email": "firma_autorizo@fas.com",
            "password": "cabsa2020"
        }
      }

      await this.axios.post(this.apiCabsaCore + 'fas/login', data, config)
        .then((dataa) => {
          this.token_auth_valid = dataa.data.response.token_auth
          localStorage.setItem("token_auth_valid", this.token_auth_valid);
      }).catch(error => {
          this.errors = this.getApiErrorMessage(error, "No fue posible iniciar sesión en Cabsa Core.")
      })
    },
    async postLoginCCapi(){
      let config = {
        headers: {
            'Content-Type': 'application/json'
        },
      }

      let data = {
        user: {
          email: "aplm@gcabsa.com.mx",
          password: "cabsa2022",
        },
      };

      await this.axios.post(this.apiCcapi + '/fas/login', data, config)
        .then((dataa) => {
          this.token_auth_ccapi = dataa.data.token_auth
          localStorage.setItem("token_auth_ccapi", this.token_auth_ccapi);
      }).catch(error => {
          this.errors = this.getApiErrorMessage(error, "No fue posible iniciar sesión en CCAPI.")
      })
    },
    async sendEmail(){

        var emailAssociateValid = this.emailIsValid(this.email_associate.trim())
        var emailClientValid = this.emailIsValid(this.email.trim())

        var msg = this.getMessageInvalidEmail(emailClientValid, emailAssociateValid)
        var swal = require('sweetalert2')

        if(msg != ""){
            if (msg.includes("asesor y cliente son inválidos.")){
                msg +="<br>No es posible enviar el correo."
                swal.fire({
                    title: "Aviso",
                    html: msg,
                    icon: "info",
                    confirmButtonText: 'OK',
                    confirmButtonColor: '#E9AD3F',
                })
            } else {
                swal.fire({
                    title: "Aviso",
                    html: msg,
                    icon: "info",
                    showCancelButton: true,
                    reverseButtons: true,
                    confirmButtonColor: '#40946C',
                    cancelButtonColor: '#E9AD3F',
                    confirmButtonText: 'Enviar',
                    cancelButtonText: "No Enviar",
                }).then((result) => {
                    if (result.value) {
                        this.send(emailAssociateValid, emailClientValid)
                    }
                });
            }
        }else{
            this.send(emailAssociateValid, emailClientValid)
        }

        
        
    },
    send(emailAssociateValid, emailClientValid){
        var emails = []

        if(emailAssociateValid && this.email_associate.trim() !="" && this.email_associate.trim() !="."){
            emails.push({"email": this.email_associate})
        }
        if(emailClientValid && this.email.trim() !="" && this.email.trim() !="."){
            emails.push({"email": this.email})
        }
        
        if(emails.length > 0){
            this.axios.post(this.apiCcapi + "/send_mail", {
            mail: {
                business: "fas",
                process_type: "firma designacion beneficiarios",
                title: "Firma Digital FAS",
                body_mail: "eyJhbGciOiJIUzI1NiJ9.eyJodG1sIjoiIn0.XM6FzZ4J0WG-Y8nAFXKaCBBs8_osDVj7l_viFVHppSo", 
                mailing_list: emails,
                urls_attachment: [
                    {
                        file: this.url_for_download_pdf,
                        name:"FirmaDigitalFAS.pdf"
                    }
                ]
                }
            })
            .then(response => {
                console.log(response.data)
                // this.sendedEmailConfirmation()
                this.email = ""
            }).catch(error => {
                console.error('[sendEmail]', error.response ? error.response.data : error)
            });
        }
    },
    getMessageInvalidEmail(emailClientValid, emailAssociateValid){
        var msg = ""
        if(emailClientValid == false || emailAssociateValid == false){
            
            if (emailClientValid == false){
                msg = "El correo electrónico del cliente '"+this.email.trim()+"' es inválido,<br>solo se enviara el correo al asesor."
            }
            if(emailAssociateValid == false){
                msg = "El correo electrónico del asesor '"+this.email_associate.trim()+"' es inválido,<br>solo se enviara el correo al cliente."
            }
            if(emailClientValid == false && emailAssociateValid == false){
                msg = "Los correos electrónicos del asesor y cliente son inválidos. <br><br>correo cliente: '"+this.email.trim()+"'<br>correo asesor: '"+this.email_associate.trim()+"'<br>"
            }
        }
        return msg
    },
    async postUploadFile(){
      let config = {
        headers: {
          'Content-Type': 'application/json'
        },
      }
      let data = {
        "token_auth": this.token_auth_ccapi,
        "file": this.url_path_response_pdf_signed,
        "document_name": this.document_type,
        "business_acronym":"fas2",
        "process":"generate_plan_costs_pdf_signed",
        "extension": "",
        "url_for_sign": window.location.toString()
        //"https://firma.autorizo.seccion17fas.com/?file=03b51bfc335395a0f5eacf6b074720ba.pdf&json_file=4f6fc7053fbc373bf1851d65cd6624f5.json"
      }
      await this.axios.post(this.apiCcapi + 'digital_signatures/upload_signed_file', data, config).then((response) => {
        if (response.data?.response?.url != ""){
          this.url_for_download_pdf = response.data.response.url
        }else {
            this.is_not_document_signed = false
        }
      }).catch(error => {
        this.errors = this.getApiErrorMessage(error)
        this.is_not_document_signed = false
      });
    },
    getPrivacynotice(){
        window.open("https://cabsacloud.ams3.digitaloceanspaces.com/store/FAS/Aviso%20de%20Privacidad%20FAS.pdf")
    },
    createArraySendToEmail(){
        let result = [{"email": ""}]
        if( this.email != "" || this.email != null || this.email_associate == "" || this.email_associate == null){
            return result = [{"email": this.email}]
        }
        if( this.email == "" || this.email == null || this.email_associate != "" || this.email_associate != null){
            return result = [{"email": this.email_associate}]
        }
        if( this.email != "" || this.email != null || this.email_associate != "" || this.email_associate != null){
            return result = [{"email": this.email}, {"email": this.email_associate}]
        }
        result
    },
    emailIsValid(value){
        var regex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if(value.match(regex)){
            return true;
        }
        return false;
    }
  },
  async beforeMount(){
    this.urlParams = new URLSearchParams(window.location.search)
    this.file = this.urlParams.get('file')
    this.json_file = this.urlParams.get('json_file')
    await this.postLogin()
    await this.postLoginCCapi()
    await this.postUrlExpiration()
    if (this.url_is_expiration == false){
        this.getJsonInformation()
        this.getPdfInformation()
    }
    this.loading = false
  }
}
</script>

<style>
#signature {
  border: double 2px transparent;
  border-radius: 5px;
  background-image: linear-gradient(white, white),
    radial-gradient(circle at top left, #3C959D, #3C959D);
  background-origin: border-box;
  background-clip: content-box, border-box;
}

@media only screen and (max-width: 650px) {
    .hideInSmallScreens {
        display: none;
    }

    /* En móvil conserva la misma cuadrícula de etiqueta y valor de Beneficios Adicionales. */
    .showInSmallScreens table {
        display: block;
        margin: 0;
    }

    .showInSmallScreens table tr:first-child {
        display: none;
    }

    .showInSmallScreens table tr:not(:first-child) {
        display: grid;
        grid-template-columns: repeat(2, minmax(0, 1fr));
        margin-bottom: 1.25rem;
    }

    .showInSmallScreens table td {
        display: block;
        min-width: 0;
        padding: .5rem .35rem;
        margin: 0 !important;
        text-align: center !important;
    }

    .showInSmallScreens table td:first-child {
        grid-column: 1 / -1;
    }

    .showInSmallScreens table td::before {
        display: block;
        color: #3C959D;
        font-weight: 400;
        text-align: center;
    }

    .showInSmallScreens table td:nth-child(1)::before { content: 'Indemnización'; }
    .showInSmallScreens table td:nth-child(2)::before { content: 'Módulos'; }
    .showInSmallScreens table td:nth-child(3)::before { content: 'Tipo'; }
    .showInSmallScreens table td:nth-child(4)::before { content: 'Protección'; }
    .showInSmallScreens table td:nth-child(5)::before { content: 'Beneficiario'; }
    .showInSmallScreens table td:nth-child(6)::before { content: 'Fecha de adquisición'; }
    .showInSmallScreens table td:nth-child(7)::before { content: 'Aportación quincenal'; }
}

@media only screen and (min-width: 650px) {
    .showInSmallScreens {
        display: none;
    }
}
</style>
